const hi = {
  questionPaperLibrary: "प्रश्न पत्र लाइब्रेरी",
  questionPaperLibraryDescription:
    "व्यक्तिगत प्रश्न बनाने और व्यापक प्रश्न पत्र तैयार करने के लिए आपका डायनेमिक कार्यक्षेत्र।",
  assessmentLibrary: "असेसमेंट लाइब्रेरी",
  assessmentLibraryDescription:
    "शेड्यूल प्रबंधित करें, प्रतिभागियों को आमंत्रित करें, और प्रदर्शन रिपोर्ट को एक केंद्रीकृत हब में ट्रैक करें।",
  myAssessmentWidgetTitle: "मेरा असेसमेंट",
  myPreferences: "मेरी प्राथमिकताएँ",
  assessmentsForYou: "आपके लिए असेसमेंट",
  exploreAssessmentsAssignedToYou: "आपको सौंपे गए असेसमेंट देखें",
  hitachiAcademy: "हिताची अकादमी",
  essentialBusinessKnowledgeTestForYou: "आपके लिए आवश्यक बिजनेस नॉलेज टेस्ट",
  continuousLearningJourneyDescription:
    "आपकी निरंतर सीखने की यात्रा में आपकी व्यावसायिक क्षमताओं को समझने और मजबूत करने में मदद के लिए तैयार किया गया",
  noActiveAssessmentsScheduledForYou:
    "आपके लिए कोई सक्रिय असेसमेंट निर्धारित नहीं है",
  upcoming: "आगामी",
  notAttempted: "प्रयास नहीं किया गया",
  myAssessmentCardDescription:
    "यह असेसमेंट GlobalLogic की कैंपस भर्ती प्रक्रिया के हिस्से के रूप में आपकी तकनीकी, विश्लेषणात्मक और समस्या-समाधान क्षमताओं का मूल्यांकन करता है।",
  totalDuration: "कुल अवधि",
  startTime: "प्रारंभ समय",
  questionAuthoring: "प्रश्न निर्माण",
  reviewQuestions: "प्रश्नों की समीक्षा करें",
  bulkUploadHistory: "बल्क अपलोड इतिहास",
  bulkActionHistory: "बल्क एक्शन इतिहास",
  editQuestion: "प्रश्न संपादित करें",
  inviteParticipants: "प्रतिभागियों को आमंत्रित करें",
  externalUserBulkUploadHistory: "बाहरी उपयोगकर्ता बल्क अपलोड इतिहास",
  assessmentSchedule: "असेसमेंट शेड्यूल",
  assessmentReport: "असेसमेंट रिपोर्ट",
  bulkHistory: "बल्क हिस्ट्री",
  myUpload: "मेरा अपलोड",
  bulkUpload: "बल्क अपलोड",
  createQuestion: "प्रश्न बनाएं",
  bulkUploadQuestions: "प्रश्नों का बल्क अपलोड",
  filters: "फ़िल्टर",
  clear: "साफ़ करें",
  searchByTitle: "शीर्षक से खोजें",
  refresh: "रीफ़्रेश",
  refreshing: "रीफ़्रेश हो रहा है",
  reviewQuestionPapers: "प्रश्न पत्रों की समीक्षा करें",
  myQuestionPapers: "मेरे प्रश्न पत्र",
  viewQuestionBank: "प्रश्न बैंक देखें",
  createNew: "नया बनाएं",
  sortBy: "इसके अनुसार क्रमबद्ध करें",
  state: "स्थिति",
  reviewed: "समीक्षित",
  reviewedTooltip:
    "वे प्रश्न पत्र दिखाएं जिनकी समीक्षा की गई है और फिर प्रकाशित किया गया है।",
  all: "सभी",
  draft: "ड्राफ्ट",
  published: "प्रकाशित",
  inReview: "समीक्षा में",
  sentBack: "वापस भेजा गया",
  readyToPublish: "प्रकाशित करने के लिए तैयार",
  draftDescription:
    "प्रश्न पत्र का निर्माण अभी जारी है और अभी शिक्षार्थियों के लिए उपलब्ध नहीं है",
  publishedDescription: "प्रश्न पत्र लाइव है और शिक्षार्थियों के लिए उपलब्ध है",
  inReviewDescription: "प्रश्न पत्र समीक्षा में है और अभी स्वीकृत नहीं हुआ है",
  sentBackDescription: "प्रश्न पत्र संशोधनों के लिए वापस भेजा गया है",
  readyToPublishDescription: "प्रश्न पत्र प्रकाशित करने के लिए तैयार है",
  createdAt: "निर्मित समय",
  updatedAt: "अपडेट किया गया समय",
  publishedAt: "प्रकाशित समय",
  descending: "अवरोही",
  ascending: "आरोही",
  success: "सफलता",
  error: "त्रुटि",
  warning: "चेतावनी",
  info: "जानकारी",
  yes: "हाँ",
  no: "नहीं",
  noMatchingContentFound: "कोई मेल खाती सामग्री नहीं मिली",
  noQuestionPapersAvailableForReview:
    "समीक्षा के लिए कोई प्रश्न पत्र उपलब्ध नहीं है",
  questionPaperNotYetCreated: "प्रश्न पत्र अभी तक बनाया नहीं गया है",
  createQuestionPaperDescription:
    "शिक्षार्थियों के कौशल और ज्ञान का मूल्यांकन करने के लिए एक प्रश्न पत्र बनाएं",
  createYourFirstQuestionPaper: "अपना पहला प्रश्न पत्र बनाएं",
  createQuestionPaperModalTitle: "प्रश्न पत्र बनाएं",
  questionsTab: "प्रश्न",
  questionPaperSettingsTab: "प्रश्न पत्र सेटिंग",
  editQuestionPaper: "प्रश्न पत्र संपादित करें",
  save: "सहेजें",
  publish: "प्रकाशित करें",
  sendForReview: "समीक्षा के लिए भेजें",
  sendingForReview: "समीक्षा के लिए भेजा जा रहा है",
  publishing: "प्रकाशित किया जा रहा है",
  clone: "क्लोन",
  delete: "हटाएं",
  view: "देखें",
  edit: "संपादित करें",
  close: "बंद करें",
  create: "बनाएं",
  creating: "बनाया जा रहा है",
  confirm: "पुष्टि करें",
  cancel: "रद्द करें",
  version: "संस्करण",
  untitled: "शीर्षकहीन",
  noVersion: "कोई संस्करण नहीं",
  title: "शीर्षक",
  status: "स्थिति",
  action: "कार्रवाई",
  createdBy: "द्वारा बनाया गया",
  createNewVersion: "+ नया संस्करण",
  createNewVersionTitle: "नया संस्करण बनाएं",
  deleteQuestionPaperPrompt: "क्या आप वाकई इस प्रश्नपत्र को हटाना चाहते हैं?",
  deleteQuestionPaperWithTitlePrompt:
    "क्या आप '{{title}}' शीर्षक वाला यह प्रश्नपत्र हटाना चाहते हैं?",
  cloneQuestionPaperPrompt: "क्या आप इस प्रश्नपत्र का क्लोन बनाना चाहते हैं?",
  publishQuestionPaperPrompt:
    "क्या आप वाकई इस प्रश्न पत्र को प्रकाशित करना चाहते हैं?",
  sendForReviewQuestionPaperPrompt:
    "क्या आप वाकई इस प्रश्न पत्र को समीक्षा के लिए भेजना चाहते हैं?",
  successfullyDeletedQuestionPaper: "प्रश्नपत्र सफलतापूर्वक हटा दिया गया",
  successfullyMovedQuestionPaperToDraft:
    "प्रश्नपत्र को ड्राफ्ट में सफलतापूर्वक ले जाया गया",
  successfullySavedQuestionPaperData: "प्रश्नपत्र डेटा सफलतापूर्वक सहेजा गया",
  successfullyClonedQuestionPaper:
    "प्रश्नपत्र का सफलतापूर्वक क्लोन तैयार किया गया",
  successfullyCreatedQuestionPaper: "सफलतापूर्वक प्रश्नपत्र तैयार किया गया",
  validationFailedWithFollowingErrors:
    "सत्यापन निम्नलिखित त्रुटियों के साथ विफल रहा:",
  failedStatusUpdateOf: "की स्थिति अपडेट विफल:",
  savedWithFollowingWarnings: "निम्नलिखित चेतावनियों के साथ सहेजा गया:",
  reviewedAndPublished: "समीक्षित और प्रकाशित",
  deleting: "हटाया जा रहा है...",
  cloning: "क्लोनिंग...",
  assessment: "आकलन",
  public: "सार्वजनिक",
  private: "निजी",
  visibility: "दृश्यता",
  questionType: "प्रश्न प्रकार",
  selectQuestionTypeAndVisibility: "प्रश्न प्रकार और दृश्यता का चयन करें",
  singleChoice: "एकल विकल्प",
  multipleChoice: "बहुविकल्पी",
  trueOrFalse: "सही या गलत",
  fillInTheBlanks: "रिक्त स्थान भरें",
  codingQuestion: "कोडिंग प्रश्न",
  subjectiveQuestion: "व्यक्तिपरक प्रश्न",
  speakingQuestion: "बोलने वाला प्रश्न",
  downloadTemplateEditAndReuploadQuestions:
    "टेम्प्लेट डाउनलोड करें, प्रश्नों की सूची संपादित करें और पुनः अपलोड करें",
  downloadExcelTemplateInstruction:
    "नीचे दिए गए बटन का उपयोग करके एक्सेल टेम्पलेट डाउनलोड करें।",
  addQuestionsToSheetInstruction:
    "अपने प्रश्नों को शीट में जोड़ें (निर्देश अंदर शामिल हैं)।",
  uploadCompletedExcelInstruction:
    "प्रश्नों को थोक में आयात करने के लिए पूर्ण एक्सेल फ़ाइल अपलोड करें।",
  uploading: "अपलोड हो रहा है...",
  uploadQuestions: "प्रश्न अपलोड करें",
  completed: "पूर्ण",
  invalid: "अमान्य",
  initiated: "शुरू किया गया",
  failed: "असफल",
  fileName: "फ़ाइल का नाम",
  templateType: "टेम्पलेट प्रकार",
  uploadedAt: "पर अपलोड किया गया",
  actions: "कार्रवाई",
  mcqTemplate: "एमसीक्यू टेम्पलेट",
  fibTemplate: "एफआईबी टेम्पलेट",
  monitorUploadExcelDescription:
    "प्रत्येक अपलोड एक्सेल फ़ाइल की निगरानी करें, जांचें कि कितने प्रश्न जोड़े गए या विफल रहे, और यदि आवश्यक हो तो त्रुटि विवरण देखें।",
  reset: "रीसेट करें",
  showing: "दिखाया जा रहा है",
  to: "को",
  of: "का",
  results: "परिणाम",
  noExcelFound: "कोई एक्सेल नहीं मिला",
  cloneAssessmentConfirmation: "क्लोन मूल्यांकन पुष्टिकरण",
  cloneAssessmentWithTitlePrompt:
    "क्या आप वाकई '{{title}}' शीर्षक वाले इस मूल्यांकन का क्लोन बनाना चाहते हैं?",
  successfullyClonedAssessment: "मूल्यांकन सफलतापूर्वक क्लोन किया गया",
  newVersionContentPrompt:
    "आप इस सामग्री का एक नया संस्करण बनाने वाले हैं. कोई भी अन्य परिवर्तन इस संस्करण में सहेजा जाएगा. क्या आप जारी रखना चाहेंगे?",
  createVersionWithNumber: "बनाएं (V{{version}})",
  addYourComment: "अपनी टिप्पणी जोड़ें",
  maxLimitReached: "अधिकतम सीमा तक पहुंच गया",
  deleteContentPrompt: "क्या आप वाकई इस {{contentType}} को हटाना चाहते हैं?",
  deleteContentWithTitlePrompt:
    "क्या आप वाकई '{{title}}' शीर्षक वाले इस {{contentType}} को हटाना चाहते हैं?",
  schedulePreview: "शेड्यूल पूर्वावलोकन",
  reschedule: "पुनर्निर्धारित",
  cancelled: "रद्द कर दिया गया",
  copyLink: "लिंक की प्रतिलिपि करें",
  assessmentIsCancelled: "मूल्यांकन रद्द कर दिया गया है",
  deleteConfirmation: "पुष्टिकरण हटाएँ",
  cancelConfirmation: "पुष्टिकरण रद्द करें",
  deleteAssessmentPrompt: "क्या आप वाकई इस मूल्यांकन को हटाना चाहते हैं?",
  cancelAssessmentPrompt: "क्या आप वाकई इस मूल्यांकन को रद्द करना चाहते हैं?",
  rescheduleAssessment: "पुनर्निर्धारित मूल्यांकन",
  customTermsAndConditions: "कस्टम नियम और शर्तें",
  viewTermsAndConditions: "नियम एवं शर्तें देखें",
  scheduleNewAssessment: "नया मूल्यांकन शेड्यूल करें",
  selectQuestionPaper: "प्रश्न पत्र का चयन करें",
  createAssessment: "मूल्यांकन बनाएं",
  failedToLoadData: "डेटा लोड करने में विफल!",
  assessmentNotYetCreated: "मूल्यांकन अभी तक नहीं बनाया गया है",
  createAssessmentDescription:
    "शिक्षार्थियों के कौशल और ज्ञान का मूल्यांकन करने के लिए एक मूल्यांकन बनाएं",
  createYourFirstAssessment: "अपना पहला मूल्यांकन बनाएं",
  failedToLoadSchedules: "शेड्यूल लोड करने में विफल",
  errors: "त्रुटियाँ:",
  basicInformation: "मूल जानकारी",
  assessmentName: "मूल्यांकन नाम",
  na: "NA",
  scheduleInstructions: "अनुसूची अनुदेश",
  noInstructionsProvided: "कोई निर्देश नहीं दिया गया",
  accessCriteria: "प्रवेश मानदंड",
  searchTags: "टैग खोजें",
  viewAttributes: "गुण देखें",
  termsAndConditions: "नियम एवं शर्तें",
  enabled: "सक्रिय",
  disabled: "अक्षम",
  requireCandidatesToAcceptTerms:
    "मूल्यांकन शुरू करने से पहले उम्मीदवारों को नियम एवं शर्तें स्वीकार करने की आवश्यकता है",
  proctoringSettings: "प्रॉक्टरिंग सेटिंग्स",
  enableVideoProctoring: "वीडियो प्रॉक्टरिंग सक्षम करें",
  maximumVideoViolationsAllowed: "अधिकतम वीडियो उल्लंघन की अनुमति",
  enableBrowserProctoring: "ब्राउज़र प्रॉक्टरिंग सक्षम करें",
  maximumBrowserViolationsAllowed: "अधिकतम ब्राउज़र उल्लंघनों की अनुमति",
  displayViolationsToCandidates: "अभ्यर्थियों को उल्लंघन प्रदर्शित करें",
  actionWhenViolationLimitReached: "उल्लंघन की सीमा तक पहुंचने पर कार्रवाई",
  flagged: "चिह्नित",
  terminate: "समाप्त",
  stakeholdersAndFeedback: "हितधारकों और प्रतिक्रिया",
  owner: "मालिक",
  recruiter: "भर्तीकर्ता",
  allowCandidateFeedback: "उम्मीदवार प्रतिक्रिया की अनुमति दें",
  enableCandidateFeedbackDescription:
    "मूल्यांकन पूरा करने के बाद उम्मीदवारों को फीडबैक सबमिट करने में सक्षम बनाएं",
  schedulingAndTimerSettings: "शेड्यूलिंग और टाइमर सेटिंग्स",
  scheduleType: "अनुसूची प्रकार",
  loginWindow: "लॉगिन विंडो",
  durationBased: "अवधि आधारित",
  deadline: "अंतिम तारीख",
  autoCompleteMode: "स्वतः पूर्ण मोड",
  startDateAndTime: "प्रारंभ दिनांक और समय",
  loginWindowInMinutes: "लॉगिन विंडो (मिनटों में)",
  endDateAndTime: "समाप्ति दिनांक एवं समय",
  timerEnabled: "टाइमर सक्षम",
  assessmentRules: "मूल्यांकन नियम",
  assessmentPattern: "मूल्यांकन पैटर्न",
  resultVisibility: "परिणाम दृश्यता",
  passPercentage: "उत्तीर्ण प्रतिशत",
  maximumAttemptsAllowed: "अधिकतम प्रयास की अनुमति",
  unlimitedAttempts: "असीमित प्रयास",
  attempt: "प्रयास",
  attempts: "प्रयास",
  coolOffPeriodBetweenAttempts: "प्रयासों के बीच कूल ऑफ अवधि",
  questionDisplaySettings: "प्रश्न प्रदर्शन सेटिंग्स",
  showQuestionTitle: "प्रश्न शीर्षक दिखाएँ",
  showQuestionTitleDescription:
    "प्रत्येक प्रश्न के ऊपर प्रश्न शीर्षक प्रदर्शित करें",
  showHint: "संकेत दिखाएँ",
  hintLoading: "आपको एक और संकेत देखने से पहले प्रतीक्षा करने की आवश्यकता है",
  allHintsShown: "कोई संकेत लंबित नहीं है",
  showHintDescription:
    "मूल्यांकन के दौरान उम्मीदवार की सहायता के लिए संकेत सक्षम करें",
  showExplanation: "स्पष्टीकरण दिखाएँ",
  hideExplanation: "स्पष्टीकरण छिपाएँ",
  showExplanationDescription:
    "प्रत्येक प्रश्न प्रस्तुत करने के बाद स्पष्टीकरण दिखाएं",
  showQuestionMarks: "प्रश्नचिह्न दिखाएँ",
  showQuestionMarksDescription:
    "प्रत्येक प्रश्न के लिए अंक/स्कोर मान प्रदर्शित करें",
  showWatermark: "वॉटरमार्क दिखाएँ",
  showWatermarkDescription:
    "प्रत्येक प्रश्न के लिए उम्मीदवार का ईमेल वॉटरमार्क के रूप में प्रदर्शित करें",
  questionPaperPreview: "प्रश्न पत्र पूर्वावलोकन",
  questionPaperReview: "प्रश्न पत्र समीक्षा",
  createSchedule: "शेड्यूल बनाएं",
  reviewerComments: "समीक्षक टिप्पणियाँ",
  reviewComments: "टिप्पणियों की समीक्षा करें",
  sendBackQuestionPaperPrompt:
    "क्या आप वाकई यह प्रश्नपत्र वापस भेजना चाहते हैं?",
  moveQuestionPaperToDraftPrompt:
    "क्या आप वाकई इस प्रश्न पत्र को ड्राफ्ट में स्थानांतरित करना चाहते हैं?",
  markQuestionPaperReadyToPublishPrompt:
    "क्या आप वाकई इस प्रश्न पत्र को प्रकाशन हेतु तैयार के रूप में चिह्नित करना चाहते हैं?",
  questionPaperStatusUpdatedSuccessfully:
    "प्रश्नपत्र की स्थिति सफलतापूर्वक अपडेट की गई!",
  newVersionQuestionPaperCreatedSuccessfully:
    "प्रश्नपत्र का नया संस्करण सफलतापूर्वक बनाया गया!",
  questionPaperClonedSuccessfully: "प्रश्न पत्र सफलतापूर्वक क्लोन किया गया!",
  startAddingQuestionsPreview:
    "यहां इसका पूर्वावलोकन करने के लिए प्रश्न जोड़ना प्रारंभ करें",
  bulkInviteParticipants: "प्रतिभागियों को थोक में आमंत्रित करें",
  bulkInviteParticipantsDescription:
    "पहले से भरी हुई एक्सेल फ़ाइल अपलोड करके एक साथ कई प्रतिभागियों को आमंत्रित करें। कृपया सही प्रारूप सुनिश्चित करने के लिए दिए गए टेम्पलेट का उपयोग करें।",
  maxParticipantsPerFileNote:
    "प्रति फ़ाइल अधिकतम 200 प्रतिभागी। डुप्लिकेट या अमान्य प्रविष्टियाँ एक त्रुटि के साथ छोड़ दी जाएंगी।",
  downloadTemplate: "टेम्पलेट डाउनलोड करें",
  creatingUser: "उपयोगकर्ता बनाया जा रहा है...",
  bulkInviteLabel: "थोक आमंत्रण",
  createAndInvite: "बनाएं और आमंत्रित करें",
  myUploads: "मेरे अपलोड",
  enterIndividualsForInvite:
    "एक या अधिक व्यक्तियों के नाम दर्ज करें जिन्हें आप मूल्यांकन के लिए आमंत्रित करना चाहते हैं",
  searchPeopleByEmailOrName: "ईमेल आईडी या नाम से लोगों को खोजें",
  noResultsFound: "कोई परिणाम नहीं मिला",
  loading: "लोड हो रहा है..",
  or: "या",
  multipleEmailsInviteDescription:
    "मूल्यांकन के लिए एकाधिक उपयोगकर्ताओं को आमंत्रित करने के लिए, अल्पविराम से अलग किए गए एकाधिक उपयोगकर्ता ईमेल जोड़ें",
  addCandidates: "उम्मीदवार जोड़ें",
  pleaseEnterValidNameOrEmail: "कृपया एक वैध नाम या ईमेल पता दर्ज करें",
  pleaseEnterValidEmailAddress: "कृपया एक मान्य ईमेल पता प्रविष्ट करें",
  someEmailsCouldNotBeAdded: "कुछ ईमेल पते जोड़े नहीं जा सके",
  checkInvalidEmailIds:
    "कृपया निम्नलिखित ईमेल आईडी की जांच करें - वे अमान्य प्रतीत होते हैं:",
  failedToSendInvitesFollowingEmails:
    "निम्नलिखित ईमेल पर आमंत्रण भेजने में विफल:",
  successfullyInvitedMembers:
    "{{count}} सदस्य को सफलतापूर्वक आमंत्रित किया गया",
  validationFailed: "प्रमाणीकरण विफल रहा",
  excelUploadedSuccessfully: "एक्सेल सफलतापूर्वक अपलोड हो गया",
  invalidBulkNominationTemplate: "अमान्य थोक नामांकन टेम्पलेट",
  actionCompletedWithWarnings:
    "कार्रवाई निम्नलिखित चेतावनियों के साथ पूरी हुई:",
  actionFailedWithErrors:
    "कार्रवाई पूरी नहीं हो सकी और निम्नलिखित त्रुटियों के साथ बाहर निकल गई:",
  trackBulkOperationsAndResults:
    "अपने सभी बड़े परिचालनों और उनके परिणामों को ट्रैक करें",
  partiallySaved: "आंशिक रूप से सहेजा गया",
  statusInitiatedDescription:
    "प्रश्न अद्यतन अनुरोध सबमिट कर दिया गया है और संसाधित किया जा रहा है।",
  statusCompletedDescription: "सभी चयनित प्रश्न सफलतापूर्वक अपडेट किए गए।",
  statusFailedDescription:
    "चयनित प्रश्नों में से कोई भी सफलतापूर्वक संसाधित नहीं किया जा सका.",
  statusPartiallySavedDescription:
    "कुछ प्रश्न सफलतापूर्वक सहेजे गए, जबकि अन्य में समस्याएं आईं।",
  draftReadyToPublishToPublish: "ड्राफ्ट/प्रकाशन के लिए तैयार -> प्रकाशित करें",
  actionType: "क्रिया प्रकार",
  uploadedOn: "पर अपलोड किया गया",
  viewDetails: "विवरण देखें",
  loadingRecords: "रिकॉर्ड लोड हो रहा है...",
  noRecordsFound: "कोई रिकॉर्ड नहीं मिला",
  recordsPerPage: "प्रति पृष्ठ रिकॉर्ड:",
  page: "पृष्ठ",
  untitledQuestion: "शीर्षक रहित प्रश्न",
  globalLogic: "ग्लोबललॉजिक",
  aiGenerated: "एआई जनरेट किया गया",
  fullScreen: "पूर्ण स्क्रीन",
  exitFullScreen: "पूर्ण स्क्रीन से बाहर निकलें",
  skills: "कौशल",
  tags: "टैग",
  allowedCodingLanguages: "अनुमत कोडिंग भाषाएँ",
  marks: "अंक",
  lastUpdatedAt: "अंतिम बार अद्यतन किया गया",
  solutionCode: "समाधान कोड",
  solution: "समाधान",
  starterCode: "स्टार्टर कोड",
  options: "विकल्प",
  explanation: "स्पष्टीकरण",
  hint: "संकेत",
  deleteQuestion: "प्रश्न हटाएँ",
  noSections: "कोई अनुभाग नहीं जोड़ा गया",
  editAndPublish: "संपादित करें और प्रकाशित करें",
  sendBackToDraftInstruction:
    "प्रश्न को ड्राफ्ट में वापस भेजने के लिए सेंड बैक बटन पर क्लिक करें।",
  updateStatusReadyToPublishInstruction:
    "स्टेटस अपडेट करने के लिए रेडी टू पब्लिश बटन पर क्लिक करें।",
  successfullyUpdatedStatus: "स्थिति सफलतापूर्वक अपडेट की गई",
  dismiss: "खारिज करें",
  ongoing: "जारी",
  toBeLaunched: "लॉन्च होना बाकी है",
  contentExpired: "सामग्री समाप्त हो चुकी है",
  notApplicable: "लागू नहीं",
  expiresSoon: "जल्द समाप्त होगा",
  contentCreationInProgressTooltip:
    "सामग्री निर्माण अभी प्रगति पर है और अभी शिक्षार्थियों के लिए उपलब्ध नहीं है",
  contentLiveAccessibleTooltip:
    "सामग्री लाइव है और शिक्षार्थियों के लिए सुलभ है",
  contentAvailableWithinDatesTooltip:
    "सामग्री वर्तमान में उपलब्ध है, क्योंकि यह लॉन्च और समाप्ति तिथियों के भीतर है",
  contentNotLaunchedAvailableOnTooltip:
    "सामग्री अभी लॉन्च नहीं हुई है और उपलब्ध होगी",
  contentExpiredOnTooltip: "यह सामग्री समाप्त हुई",
  statusAvailableAfterPublishTooltip:
    "सामग्री प्रकाशित होने के बाद ही स्थिति उपलब्ध होगी",
  contentExpiresWithin48HoursTooltip:
    "यह सामग्री 48 घंटों के भीतर समाप्त होने वाली है।",
  moveToDraftOrCloneToEdit:
    "इसे ड्राफ्ट में भेजें या संपादन करने के लिए इसका क्लोन बनाएं",
  webContent: "वेब सामग्री",
  eLearning: "ई-लर्निंग",
  untitledContent: "बिना शीर्षक की सामग्री",
  sendToDraft: "ड्राफ्ट में भेजें",
  sendToDraftPublishedInstruction:
    'यह सामग्री पहले से प्रकाशित है। बदलाव करने के लिए "ड्राफ्ट में भेजें" बटन पर क्लिक करें।',
  copyLinkForLearner: "शिक्षार्थी के लिए लिंक कॉपी करें",
  questionPaperName: "प्रश्न पत्र का नाम",
  type: "प्रकार",
  duration: "अवधि",
  minutes: "मिनट",
  difficultyLevel: "कठिनाई स्तर",
  language: "भाषा",
  timezone: "समय क्षेत्र",
  preferredLocation: "पसंदीदा स्थान",
  notSelected: "चयनित नहीं",
  selectedPreferencesHeading: "चयनित प्राथमिकताएँ",
  selectedPreferencesInfo: "सहज अनुभव के लिए चयनित प्राथमिकताएँ",
  shortDescription: "संक्षिप्त विवरण",
  totalMarks: "कुल अंक",
  questionPaperInstructions: "प्रश्न पत्र निर्देश",
  expiryDate: "समाप्ति तिथि",
  knowledgeCategory: "ज्ञान श्रेणी",
  category: "श्रेणी",
  subCategory: "उप-श्रेणी",
  region: "क्षेत्र",
  usage: "उपयोग",
  internalUseOnly: "केवल आंतरिक उपयोग",
  externalUseOnly: "केवल बाहरी उपयोग",
  availableForAll: "सभी के लिए उपलब्ध",
  apac: "एपीएसी",
  emea: "ईएमईए",
  latinAmerica: "लैटिन अमेरिका",
  northAmerica: "उत्तरी अमेरिका",
  globalRegion: "वैश्विक",
  automotive: "ऑटोमोटिव",
  bankingFinancialServicesInsurance: "बैंकिंग, वित्तीय सेवाएँ और बीमा",
  connectivitySolutionsCommunication: "कनेक्टिविटी समाधान/संचार",
  consumerRetail: "उपभोक्ता एवं खुदरा",
  healthcareLifeSciences: "स्वास्थ्य सेवा एवं जीवन विज्ञान",
  manufacturingAndIndustrial: "निर्माण और औद्योगिक",
  mediaEntertainment: "मीडिया एवं मनोरंजन",
  technology: "प्रौद्योगिकी",
  other: "अन्य",
  behavioralInterpersonal: "व्यवहारिक/अंतरव्यक्तीय",
  technical: "तकनीकी",
  processAndTools: "प्रक्रिया और उपकरण",
  polishLanguage: "पोलिश",
  spanishLanguage: "स्पेनिश",
  japaneseLanguage: "जापानी",
  germanLanguage: "जर्मन",
  ukrainianLanguage: "यूक्रेनी",
  swedishLanguage: "स्वीडिश",
  romanianLanguage: "रोमानियाई",
  slovakLanguage: "स्लोवाक",
  croatianLanguage: "क्रोएशियाई",
  englishUsLanguage: "अंग्रेज़ी (US)",
  englishUkLanguage: "अंग्रेज़ी (UK)",
  englishInLanguage: "अंग्रेज़ी (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "ऑटोमोटिव मानक और प्रोटोकॉल",
  businessAnalysis: "व्यावसायिक विश्लेषण",
  cCpp: "C/C++",
  cloudDataScience: "क्लाउड डेटा साइंस",
  bigData: "बिग डेटा",
  dataAnalytics: "डेटा एनालिटिक्स",
  databaseTech: "डेटाबेस",
  developmentTools: "डेवलपमेंट टूल्स",
  devops: "DevOps",
  embedded: "एम्बेडेड",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux Kernel",
  mobileDev: "मोबाइल डेवलपमेंट",
  networking: "नेटवर्किंग",
  operatingSystemsServers: "ऑपरेटिंग सिस्टम और सर्वर",
  otherTech: "अन्य - टेक",
  productivityTools: "प्रोडक्टिविटी टूल्स",
  programmingLangOther: "प्रोग्रामिंग लैंग - अन्य",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "सॉफ्टवेयर इंजीनियरिंग",
  uxUi: "UX/UI",
  architectureTech: "आर्किटेक्चर",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "रिक्वायरमेंट इंजीनियरिंग/टेक्निकल राइटिंग",
  onboarding: "ऑनबोर्डिंग",
  glTools: "GL टूल्स",
  processAndPolicies: "प्रक्रियाएँ और नीतियाँ",
  communicationSubCategory: "संचार",
  personalEffectiveness: "व्यक्तिगत प्रभावशीलता",
  methodologies: "पद्धतियाँ",
  projectManagement: "परियोजना प्रबंधन",
  peopleManagement: "लोग प्रबंधन",
  leadershipPrograms: "नेतृत्व कार्यक्रम",
  domain: "डोमेन",
  reviewer: "समीक्षक",
  none: "कोई नहीं",
  questionPaperPreviewBreadcrumb: "प्रश्न पत्र पूर्वावलोकन: {{title}}",
  questionPaperInReviewContactReviewer:
    "यह प्रश्न पत्र वर्तमान में समीक्षा में है। कृपया समीक्षक से संपर्क करें।",
  randomization: "यादृच्छिकीकरण",
  randomizationInSectionDescription:
    "इस अनुभाग के प्रश्न उम्मीदवारों को यादृच्छिक क्रम में दिखाए जाएंगे",
  questionPreviewPlaceholderImage: "प्रश्न पूर्वावलोकन प्लेसहोल्डर",
  createNewVersionPromptWithNumber: "नया संस्करण बनाएं (V{{version}})?",
  questionPreviewBreadcrumb: "प्रश्न पूर्वावलोकन: {{title}}",
  questionPreviewTitle: "प्रश्न पूर्वावलोकन",
  adminView: "एडमिन दृश्य",
  candidateView: "उम्मीदवार दृश्य",
  viewAsCandidate: "उम्मीदवार के रूप में देखें",
  closePanel: "पैनल बंद करें",
  internalQuestion: "आंतरिक प्रश्न",
  expiresOn: "समाप्ति तिथि",
  expiredLabel: "समाप्त",
  solutionNotAdded: "समाधान नहीं जोड़ा गया",
  testCases: "टेस्ट केस",
  testCasesNotAdded: "टेस्ट केस नहीं जोड़े गए",
  starterCodeNotAdded: "स्टार्टर कोड नहीं जोड़ा गया",
  groupTitleLengthValidation:
    "समूह शीर्षक 5 अक्षरों से अधिक और 120 अक्षरों से कम होना चाहिए",
  addTitleHere: "यहां शीर्षक जोड़ें...",
  groupUpdatedSuccessfully: "समूह सफलतापूर्वक अपडेट हुआ",
  groupDeletedSuccessfully: "समूह सफलतापूर्वक हटाया गया",
  group: "समूह",
  numberOfQuestionsToBeShown: "दिखाए जाने वाले प्रश्नों की संख्या",
  questionLimitPerSectionDescription:
    "अनुभागों में उम्मीदवारों को केवल एक निश्चित संख्या में प्रश्न दिखाएं",
  numberOfQuestionsToShow:
    "दिखाने के लिए प्रश्नों की संख्या {{picked}}/{{total}}",
  collapseGroup: "समूह संक्षिप्त करें",
  expandGroup: "समूह विस्तृत करें",
  groupSetupStartAddingQuestions:
    "इस अनुभाग के लिए एक समूह तैयार है। इसमें प्रश्न जोड़ना शुरू करें।",
  addMoreQuestions: "और प्रश्न जोड़ें",
  addQuestionFromLibrary: "लाइब्रेरी से प्रश्न जोड़ें",
  questionDeletedSuccessfully: "प्रश्न सफलतापूर्वक हटाया गया",
  questionsShownCountUpdated:
    "दिखाए जाने वाले प्रश्नों की संख्या अपडेट कर दी गई है",
  failedToDeleteQuestion: "प्रश्न हटाने में विफल",
  caseSensitive: "बड़े-छोटे अक्षरों के प्रति संवेदनशील",
  caseSensitiveDescription:
    "यदि सक्षम है, तो शिक्षार्थियों को उत्तर बिल्कुल वही बड़े और छोटे अक्षरों के साथ दर्ज करना होगा।",
  enterYourAnswerBelow: "नीचे अपना उत्तर दर्ज करें",
  caseSensitiveAnswerInfo:
    "यह प्रश्न बड़े-छोटे अक्षरों के प्रति संवेदनशील है, इसलिए कृपया अपने उत्तर बिल्कुल सही बड़े और छोटे अक्षरों के साथ दर्ज करें।",
  answerWithNumber: "उत्तर {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com,user2@globallogic.com",
  visibleTestCases: "दृश्यमान टेस्ट केस",
  hiddenTestCases: "छिपे हुए टेस्ट केस",
  visibleLabel: "दृश्यमान",
  hiddenLabel: "छिपा हुआ",
  responseSetting: "प्रतिक्रिया सेटिंग",
  recordingLimit: "रिकॉर्डिंग सीमा",
  minimumResponseDuration: "न्यूनतम प्रतिक्रिया अवधि",
  uploadLimit: "अपलोड सीमा",
  practiceAllowed: "अभ्यास की अनुमति",
  standardEvaluationRubricInfo:
    "यह मानक मूल्यांकन रूब्रिक है जिसका उपयोग इस प्रश्न पर उम्मीदवार की प्रतिक्रिया का आकलन करने के लिए किया जाएगा।",
  criteria: "मानदंड",
  weightPercentage: "भार(%)",
  viewRemarks: "टिप्पणियां देखें",
  input: "इनपुट",
  expectedOutput: "अपेक्षित आउटपुट",
  actualOutput: "वास्तविक आउटपुट",
  untitledSection: "अशीर्षक अनुभाग",
  testSectionDescription: "परीक्षण अनुभाग विवरण",
  groupAddedSuccessfully: "समूह सफलतापूर्वक जोड़ा गया",
  addGroupToSection: "अनुभाग में समूह जोड़ें",
  deleteSection: "अनुभाग हटाएं",
  questionPaperDetails: "प्रश्न पत्र विवरण",
  skillsInfoMessage:
    "इस प्रश्न पत्र का मूल्यांकन करने के लिए आवश्यक मुख्य कौशल सूचीबद्ध करें।",
  contentSettings: "सामग्री सेटिंग्स",
  stakeholderAndReview: "हितधारक और समीक्षा",
  statusType: "स्थिति प्रकार",
  notReviewed: "समीक्षा नहीं की गई",
  sourceType: "स्रोत प्रकार",
  proficiency: "प्रवीणता",
  beginner: "शुरुआती",
  intermediate: "मध्यवर्ती",
  advanced: "विकसित",
  wecp: "डब्ल्यूईसीपी",
  enterMarks: "अंक दर्ज करें",
  removeSkill: "कौशल हटाओ",
  searchSkills: "खोज कौशल",
  noSkillsFound: "कोई कौशल नहीं मिला.",
  enterTag: "एक टैग दर्ज करें",
  enterOwner: "स्वामी दर्ज करें",
  enterReviewer: "समीक्षक दर्ज करें",
  noUserWithRole: "इस भूमिका वाला कोई उपयोगकर्ता नहीं मिला",
  createSection: "अनुभाग बनाएँ",
  untitledGroup: "शीर्षकहीन समूह",
  createGroup: "समूह बनाना",
  collapseSections: "अनुभागों को संक्षिप्त करें",
  expandSections: "अनुभागों का विस्तार करें",
  assessmentNamePlaceholder: "कृपया मूल्यांकन नाम दर्ज करें",
  questionPaperTitleInfo:
    "प्रश्न पत्र के लिए एक स्पष्ट, वर्णनात्मक शीर्षक दर्ज करें।",
  shortDescriptionPlaceholder: "एक संक्षिप्त विवरण प्रदान करें",
  shortDescriptionInfo:
    "एक संक्षिप्त सारांश जिसमें बताया गया है कि प्रश्नपत्र में क्या शामिल है।",
  questionPaperInstructionsInfo:
    "वे निर्देश लिखें जो अभ्यर्थी प्रश्न पत्र शुरू करने से पहले देखेंगे। अनुभाग नियम, प्रश्न प्रारूप, नेविगेशन युक्तियाँ और सबमिशन दिशानिर्देश जैसे महत्वपूर्ण विवरण शामिल करें।",
  questionPaperInstructionsPlaceholder:
    "मूल्यांकन शुरू करने से पहले शिक्षार्थियों के लिए कोई महत्वपूर्ण निर्देश जोड़ें - अवधि, उत्तीर्ण मानदंड, अनुमत उपकरण, या दिशानिर्देश।",
  totalMarksAutoCalculatedInfo:
    "प्रत्येक समूह के लिए चयनित प्रश्नों की संख्या के आधार पर कुल अंकों की गणना स्वचालित रूप से की जाएगी। यदि दिखाए जाने वाले प्रश्नों की संख्या 0 पर सेट है, तो उस समूह को कुल अंकों से बाहर कर दिया जाएगा।",
  questionPaperType: "प्रश्न पत्र का प्रकार",
  questionPaperTypeInfo: "प्रश्न पत्र का प्रारूप चुनें.",
  durationInfo:
    "प्रश्न पत्र पूरा करने की कुल समय सीमा (मिनटों में) निर्धारित करें।",
  difficultyLevelInfo:
    "उम्मीदवार के अनुभव के आधार पर अपेक्षित कठिनाई स्तर का चयन करें।",
  languageInfo: "वह भाषा चुनें जिसमें प्रश्न पत्र प्रस्तुत किया जाएगा।",
  tagsInfo:
    "खोज के माध्यम से दूसरों को यह प्रश्न पत्र ढूंढने में मदद करने के लिए कीवर्ड जोड़ें।",
  selectCategory: "श्रेणी चुनना",
  createLevel: "बनाएं",
  evaluate: "मूल्यांकन करना",
  analyze: "विश्लेषण करें",
  apply: "आवेदन करना",
  understand: "समझना",
  remember: "याद करना",
  allowedCodingLanguagesRequiredInfo:
    "फ़ील्ड की आवश्यकता केवल तभी होती है जब आप प्रश्न पत्र में कोडिंग प्रश्न जोड़ते हैं।",
  knowledgeCategoryInfo:
    "इस प्रश्न पत्र द्वारा लक्षित संज्ञानात्मक कौशल स्तर का चयन करें, जैसे, याद रखें, समझें, लागू करें।",
  allowedCodingLanguagesInfo:
    "इस प्रश्न पत्र में प्रश्नों को कोड करने के लिए अनुमत प्रोग्रामिंग भाषाओं का चयन करें।",
  expiryDateInfo:
    "एक वैकल्पिक तिथि निर्धारित करें जिसके बाद इस प्रश्न पत्र का उपयोग नहीं किया जाना चाहिए।",
  visibilityInfo: "प्रश्न पत्र की दृश्यता का चयन करें",
  visibilityLockedInfo:
    "एक बार जब कोई प्रश्न पत्र सार्वजनिक दृश्यता के साथ प्रकाशित हो जाता है, तो उसके सभी अन्य संस्करणों को भी सार्वजनिक दृश्यता मिल जाएगी। इसी प्रकार, यदि इसे निजी के रूप में प्रकाशित किया जाता है, तो सभी संस्करण निजी ही रहेंगे।",
  reviewRequired: "समीक्षा आवश्यक है",
  reviewRequiredLockedInfo:
    "'समीक्षा आवश्यक' सेटिंग प्रश्न पत्र के सभी संस्करणों में समन्वयित है। यदि कोई संस्करण समीक्षा सक्षम या अक्षम के साथ प्रकाशित किया गया है, तो सभी संस्करणों पर एक ही सेटिंग लागू होगी, और व्यक्तिगत रूप से संपादित नहीं किया जा सकता है।",
  reviewRequiredInfo:
    "यदि इस प्रश्न पत्र को प्रकाशित करने से पहले औपचारिक समीक्षा प्रक्रिया से गुजरना होगा तो सक्षम करें।",
  savingData: "डेटा सहेजा जा रहा है...",
  questionDataSavedSuccessfully: "प्रश्न डेटा सफलतापूर्वक सहेजा गया",
  sendQuestionForReviewInstruction:
    "इसकी समीक्षा करवाने के लिए इसे समीक्षक के पास भेजने के लिए समीक्षा के लिए भेजें बटन पर क्लिक करें!",
  publishQuestionInstruction:
    "प्रश्न प्रकाशित करने के लिए प्रकाशित बटन पर क्लिक करें।",
  noLearningContentAddedAfterSelectingYes:
    "हां चुनने के बाद कोई शिक्षण सामग्री नहीं जोड़ी गई",
  expectedTimeInMinutes: "अपेक्षित समय(मिनट में)",
  codingMarksAutoCalculatedInfo:
    "इस प्रश्न में जोड़े गए छिपे हुए परीक्षण मामलों के आधार पर इस अंक की गणना स्वचालित रूप से की जाती है",
  skillsInfoMessageQuestion:
    "विशिष्ट कौशल प्रदान करें जो प्रतिभागी प्रश्न से प्राप्त करेंगे",
  skillsSubtitleQuestion: "इस प्रश्न से जुड़े कौशल निर्धारित करें",
  allowedCodingLanguagesInfoQuestion:
    "इस प्रश्न को हल करने के लिए उपलब्ध भाषाएँ चुनें",
  selectCodingLanguages: "कोडिंग भाषाएँ चुनें",
  allLanguages: "सभी भाषाएँ",
  tagsInfoQuestion:
    "घटना को वर्गीकृत करने, वर्णन करने और पहचानने के लिए कीवर्ड प्रदान करें",
  tagsSubtitleQuestion: "त्वरित खोज के लिए टैग सेट करें",
  knowledgeCategorySubtitleQuestion:
    "संज्ञानात्मक कौशल स्तर के आधार पर प्रश्नों को वर्गीकृत करने में मदद करता है।",
  explanationNotAvailableForSpeakingQuestion:
    "बोलने वाले प्रश्न के लिए स्पष्टीकरण उपलब्ध नहीं है",
  ownerVersionSyncInfo:
    "यदि हम इस संस्करण का स्वामी बदलते हैं तो यह सभी निर्मित संस्करणों में भी अपडेट हो जाएगा।",
  ownerInfoMessage: "प्रश्न के प्राथमिक स्वामी(ओं) का चयन करें",
  ownerReviewerCannotBeSame: "मालिक और समीक्षक एक नहीं हो सकते",
  reviewerInfoMessage:
    "समीक्षक के रूप में किसी व्यक्ति या व्यक्तियों के समूह का चयन करें",
  stakeholdersUpdatedSuccessfully: "हितधारकों को सफलतापूर्वक अद्यतन किया गया!",
  unexpectedErrorCreatingNewVersion:
    "नया संस्करण बनाते समय एक अप्रत्याशित त्रुटि उत्पन्न हुई.",
  previewAndPublish: "पूर्वावलोकन करें और प्रकाशित करें",
  viewAnalytics: "विश्लेषिकी देखें",
  cloneQuestionPrompt: "क्या आप इस प्रश्न का क्लोन बनाना चाहते हैं?",
  evaluationRubric: "मूल्यांकन रूब्रिक",
  problemStatement: "समस्या का विवरण",
  problemStatementPlaceholder:
    "प्रश्नोत्तरी के लिए समस्या कथन या कथन दर्ज करें",
  addOptionsAndMarkCorrectAnswer: "विकल्प जोड़ें और सही उत्तर को चिह्नित करें",
  markCorrectAnswer: "सही उत्तर चिन्हित करें",
  addCorrectAnswer: "सही उत्तर जोड़ें",
  enterCorrectAnswerForBlank: "रिक्त {{number}} के लिए सही उत्तर दर्ज करें",
  blankWithNumber: "रिक्त {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "उत्तर को सक्षम करने के लिए '&रिक्त' के साथ एक उचित समस्या विवरण जोड़ें।",
  enterSolution: "समाधान दर्ज करें",
  enterExplanation: "स्पष्टीकरण दर्ज करें",
  codingSolutionExplanationPlaceholder:
    "इष्टतम समाधान में संभाले गए तर्क, दृष्टिकोण और किनारे के मामलों को संक्षेप में समझाएं",
  optionWithNumber: "विकल्प {{number}}",
  enterExplanationForAnswer: "उत्तर के लिए स्पष्टीकरण दर्ज करें {{number}}",
  addOptionToEnableExplanation:
    "स्पष्टीकरण सक्षम करने के लिए विकल्प {{number}} जोड़ें।",
  enterExplanationForBlank: "रिक्त {{number}} के लिए स्पष्टीकरण दर्ज करें",
  addProblemStatementWithBlankToEnableExplanation:
    "स्पष्टीकरण को सक्षम करने के लिए '&रिक्त' के साथ एक उचित समस्या विवरण जोड़ें।",
  enterHint: "संकेत दर्ज करें",
  addUpTo3Hints: "3 संकेत तक जोड़ें",
  addMoreOptions: "और विकल्प जोड़ें",
  answer: "उत्तर",
  exitCodeBlockInfo:
    'कोड ब्लॉक से बाहर निकलने के लिए, पंक्ति के अंत में जाएँ और तीन बार "Enter" पर क्लिक करें',
  fibBlankInsertionInfo:
    'रिक्त जोड़ने के लिए, टेक्स्ट का चयन करें और "खाली डालें" बटन पर क्लिक करें, या मैन्युअल रूप से &blankN जोड़ें, जहां N कोई भी पूर्णांक हो सकता है जैसे: &blank1;',
  htmlEditorAccessInfo:
    "कोड जोड़ने या प्रारूप पर नियंत्रण रखने के लिए, आप संपादन आइकन पर क्लिक करके HTML संपादक तक पहुंच सकते हैं",
  skillSelectionCannotBeEmpty: "कौशल चयन खाली नहीं हो सकता",
  maxDurationInfo:
    "किसी उपयोगकर्ता को इस प्रश्न के लिए अपनी प्रतिक्रिया रिकॉर्ड करने के लिए अधिकतम समय की अनुमति है।",
  minDurationInfo:
    "उपयोगकर्ता को अपनी प्रतिक्रिया सबमिट करने से पहले न्यूनतम आवश्यक रिकॉर्डिंग समय पूरा करना होगा।",
  uploadLimitInfo:
    "अंतिम सबमिशन से पहले उपयोगकर्ता कितनी बार अपनी प्रतिक्रिया दोबारा रिकॉर्ड कर सकता है।",
  textQuestionTitle: "यह एक पाठ्य प्रश्न है",
  audioRecordQuestionTitle: "यह एक ऑडियो रिकॉर्ड प्रश्न है",
  audioUploadQuestionTitle: "यह एक ऑडियो अपलोड प्रश्न है",
  videoRecordQuestionTitle: "यह एक वीडियो रिकॉर्ड प्रश्न है",
  videoUploadQuestionTitle: "यह एक वीडियो अपलोड प्रश्न है",
  subjectiveQuestionUploadConfigTitle:
    "व्यक्तिपरक प्रश्न अपलोड कॉन्फ़िगरेशन शीर्षक",
  recordingLimitInMinutes: "रिकॉर्डिंग सीमा(मिनट में)",
  minimumResponseDurationInMinutes: "न्यूनतम प्रतिक्रिया अवधि(मिनट में)",
  recordingLimitLessThanTwenty: "रिकॉर्डिंग सीमा 20 से कम होनी चाहिए",
  recordingLimitGreaterThanOrEqualOne:
    "रिकॉर्डिंग सीमा 1 से अधिक या उसके बराबर होनी चाहिए",
  minimumDurationLessThanRecordingLimit:
    "न्यूनतम प्रतिक्रिया अवधि रिकॉर्डिंग सीमा से कम होनी चाहिए",
  durationGreaterThanPointFive: "अवधि 0.5 से अधिक होनी चाहिए",
  uploadLimitGreaterThanZero: "अपलोड सीमा 0 से अधिक होनी चाहिए",
  addFieldSelectCodingLanguagesInfo:
    "{{fieldLabel}} जोड़ने के लिए, कृपया पहले '{{basicDetails}}' अनुभाग में अनुमत कोडिंग भाषाओं का चयन करें।",
  basicDetails: "बुनियादी विवरण",
  loadingEditor: "संपादक लोड हो रहा है...",
  run: "चलाएँ",
  writingSolutionInLanguage: "आप वर्तमान में एक समाधान लिख रहे हैं",
  changingToLanguageWillClearInput: "में बदल रहा हूँ",
  unsavedChangesWillBeLostInLanguage: "आपका सहेजा नहीं गया परिवर्तन",
  changeLanguage: "भाषा बदलें",
  testCase: "परीक्षण मामला",
  add: "जोड़ना",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "नीचे कम से कम 2 दृश्यमान परीक्षण मामले और 3 छिपे हुए परीक्षण मामले जोड़ें",
  visibleToCandidatesForSelfEvaluation:
    "स्व-मूल्यांकन के लिए उम्मीदवारों के लिए दृश्यमान",
  noVisibleTestCasesAddedYet:
    "अभी तक कोई दृश्यमान परीक्षण मामला नहीं जोड़ा गया है। एक जोड़ने के लिए नीचे दिए गए बटन पर क्लिक करें।",
  visibleTestCasesCannotExceedTwenty:
    "दृश्यमान टेस्टकेस 20 से अधिक नहीं हो सकते",
  addMoreVisibleTestCases: "अधिक दृश्यमान परीक्षण मामले जोड़ें",
  maximumTestCasesLimitReached: "अधिकतम टेस्टकेस सीमा पूरी हो गई",
  hiddenToCandidatesRunsAfterSubmit:
    "उम्मीदवारों के लिए छिपा हुआ, उम्मीदवार के सबमिट करने के बाद चलता है",
  noHiddenTestCasesAddedYet:
    "अभी तक कोई छिपा हुआ परीक्षण मामला नहीं जोड़ा गया है। एक जोड़ने के लिए नीचे दिए गए बटन पर क्लिक करें।",
  hiddenTestCasesCannotExceedTen: "छिपे हुए टेस्टकेस 10 से अधिक नहीं हो सकते",
  addMoreHiddenTestCases: "अधिक छिपे हुए परीक्षण मामले जोड़ें",
  hiddenTestCase: "हिडन टेस्ट केस",
  visibleTestCase: "दर्शनीय परीक्षण मामला",
  someQuestionsCouldNotBeUpdated:
    "कुछ प्रश्न अद्यतन नहीं किये जा सके. कृपया प्रश्नों की समीक्षा करें और पुनः प्रयास करें।",
  publishSummary: "सारांश प्रकाशित करें",
  sendForReviewSummary: "समीक्षा सारांश के लिए भेजें",
  moveToDraftSummary: "ड्राफ्ट सारांश पर जाएँ",
  actionSummary: "कार्रवाई सारांश",
  publishSummarySubtitle:
    "यहां आपकी प्रकाशन कार्रवाई का सारांश दिया गया है. नीचे दिए गए विवरण की समीक्षा करें.",
  sendForReviewSummarySubtitle:
    "यहां आपके समीक्षा अनुरोध का सारांश दिया गया है. नीचे दिए गए विवरण की समीक्षा करें.",
  moveToDraftSummarySubtitle:
    "कार्रवाई का मसौदा तैयार करने की ओर आपके कदम का सारांश यहां दिया गया है। नीचे दिए गए विवरण की समीक्षा करें.",
  actionSummarySubtitle:
    "यहां आपकी कार्रवाई का सारांश है. नीचे दिए गए विवरण की समीक्षा करें.",
  successfully: "सफलतापूर्वक",
  failedTo: "करने में विफल",
  moveToDraft: "ड्राफ्ट पर जाएँ",
  details: "विवरण",
  questionTitle: "प्रश्न शीर्षक",
  reason: "कारण",
  showLess: "कम दिखाओ",
  showMoreCount: "{{count}} और दिखाएँ",
  uploadedAllCountItems: "सभी {{count}} {{item}} अपलोड कर दिए गए",
  partiallyUploadedCountItems:
    "आंशिक रूप से अपलोड किया गया {{successCount}}/{{totalCount}} {{item}}",
  users: "उपयोगकर्ताओं",
  questions: "प्रश्न",
  viewErrors: "त्रुटियाँ देखें",
  errorsWithFileName: "त्रुटियाँ - {{fileName}}",
  inputIsRequired: "इनपुट आवश्यक है",
  expectedOutputIsRequired: "अपेक्षित आउटपुट आवश्यक है",
  expectedOutputCannotBeBlank:
    "अपेक्षित आउटपुट खाली या केवल रिक्त स्थान नहीं होना चाहिए",
  marksMustBeNumber: "अंक एक संख्या होनी चाहिए",
  marksAreRequired: "अंक आवश्यक हैं",
  hiddenTestCaseMarksGreaterThanZero:
    "आगे बढ़ने के लिए छिपे हुए परीक्षण मामलों के अंक 0 से अधिक होने चाहिए।",
  hiddenTestCaseMarksMaxThirtyThousand:
    "छिपे हुए परीक्षण मामलों के लिए अंक 30,000 से अधिक नहीं होने चाहिए।",
  explanationMinFiveIfProvided:
    "यदि स्पष्टीकरण दिया गया है तो वह कम से कम 5 अक्षर का होना चाहिए",
  explanationIsRequired: "स्पष्टीकरण आवश्यक है",
  explanationMinFiveNotBlank:
    "स्पष्टीकरण कम से कम 5 अक्षर का होना चाहिए न कि केवल रिक्त स्थान का",
  provideInput: "इनपुट प्रदान करें",
  provideExpectedOutput: "अपेक्षित आउटपुट प्रदान करें",
  enterScore: "स्कोर दर्ज करें",
  optional: "वैकल्पिक",
  explainTestCase: "परीक्षण मामले की व्याख्या करें",
  updateTestCase: "टेस्ट केस अपडेट करें",
  addTestCase: "टेस्ट केस जोड़ें",
  deleteQuestionWithTitlePrompt:
    "क्या आप वाकई '{{title}}' शीर्षक वाले इस प्रश्न को हटाना चाहते हैं?",
  errorFetchingData: "डेटा लाने में त्रुटि",
  rowNumber: "पंक्ति नंबर",
  columnName: "कॉलम का नाम",
  useCase: "उदाहरण",
  startsAt: "पर शुरू होता है",
  endsAt: "पर समाप्त होता है",
  invite: "आमंत्रित करना",
  viewReport: "रिपोर्ट देखें",
  successfullyDeletedAssessment: "मूल्यांकन सफलतापूर्वक हटा दिया गया",
  successfullyFreezeActionAssessment: "मूल्यांकन सफलतापूर्वक {{action}}",
  freezeOperationFailed: "फ़्रीज़ ऑपरेशन विफल",
  deleteAssessmentWithTitlePrompt:
    "क्या आप वाकई '{{title}}' शीर्षक वाले इस मूल्यांकन को हटाना चाहते हैं?",
  freeze: "जमाना",
  unfreeze: "अनफ़्रीज़",
  freezeAssessmentPrompt:
    "क्या आप वाकई इस मूल्यांकन को {{action}} करना चाहते हैं?",
  expiresAt: "पर समाप्त होता है",
  seePreview: "पूर्वावलोकन देखें",
  schedule: "अनुसूची",
  skillBenchmarking: "कौशल बेंचमार्किंग",
  skillBenchmarkingOverview:
    "विशिष्ट कौशलों में प्रतिभागी की दक्षता का अवलोकन।",
  proctoringAnalysis: "प्रॉक्टरिंग विश्लेषण",
  proctoringAnalysisOverview:
    "मूल्यांकन के प्रॉक्टरिंग-संबंधित पहलुओं का एक त्वरित अवलोकन।",
  proctoringStatus: "प्रॉक्टरिंग स्थिति",
  noIrregularitiesReported: "किसी अनियमितता की सूचना नहीं है.",
  monitoringOverview: "निगरानी अवलोकन",
  complianceNoIncidents:
    "मूल्यांकन नियमों का अनुपालन; कोई घटना या चिह्नित व्यवहार नहीं.",
  viewEvidenceClicked: "क्लिक किए गए सबूत!",
  marksObtained: "अंक प्राप्त की",
  correctAnswer: "सही जवाब",
  wrongAnswer: "गलत जवाब",
  sectionWiseAnalysis: "अनुभागवार विश्लेषण",
  sectionWiseAnalysisOverview:
    "प्रत्येक प्रश्न और उम्मीदवार की प्रतिक्रिया का अवलोकन।",
  openAllSections: "सभी अनुभाग खोलें",
  closeAllSections: "सभी अनुभाग बंद करें",
  sectionWithNumber: "अनुभाग {{number}}:",
  score: "अंक",
  questionAnalysis: "प्रश्न विश्लेषण",
  questionTitleFallback: "प्रश्न शीर्षक",
  candidateAnswer: "अभ्यर्थी उत्तर",
  loadAllQuestions: "सभी {{count}} {{item}} लोड करें",
  attemptWithNumber: "प्रयास #{{number}}",
  invalidReportUrl: "अमान्य रिपोर्ट यूआरएल",
  failedToDownloadReportTryAgainLater:
    "रिपोर्ट डाउनलोड करने में विफल. कृपया बाद में पुन: प्रयास करें!",
  downloadReport: "रिपोर्ट डाउनलोड करें",
  participantName: "प्रतिभागी का नाम",
  dateOfAttempt: "प्रयास की तिथि",
  fail: "असफल",
  pass: "उत्तीर्ण",
  userScoredInAssessment:
    "मूल्यांकन में {{name}} ने {{percentage}} स्कोर किया।",
  overallSummary: "समग्र सारांश",
  sectionAnalytics: "अनुभाग विश्लेषिकी",
  allAttempts: "सभी प्रयास",
  bestAttempt: "सर्वोत्तम प्रयास",
  latestAttempt: "नवीनतम प्रयास",
  participantList: "प्रतिभागियों की सूची",
  totalParticipantsInvited: "कुल आमंत्रित प्रतिभागी",
  notStarted: "शुरू नहीं",
  inProgress: "प्रगति पर है",
  resultsInProgress: "परिणाम प्रगति पर हैं",
  searchByNameOrEmail: "नाम या ईमेल से खोजें",
  noUsersAvailableReportCannotBeGenerated:
    "कोई उपयोगकर्ता उपलब्ध नहीं - रिपोर्ट तैयार नहीं की जा सकती.",
  userName: "उपयोगकर्ता नाम",
  totalAttempt: "कुल प्रयास",
  percentage: "प्रतिशत(%)",
  attemptTimeline: "प्रयास समयरेखा",
  noDataFound: "डाटा प्राप्त नहीं हुआ",
  outOfMarks: "{{max}} में से {{obtained}} अंक",
  resultInProcess: "परिणाम प्रक्रिया में है",
  participantNotFound: "प्रतिभागी नहीं मिला!",
  searchedParticipantNotFound: "खोजा गया प्रतिभागी नहीं मिला!",
  noParticipantEnrolled: "कोई प्रतिभागी नामांकित नहीं है!",
  noDataToDisplay: "दिखाने के लिए कोई डेटा नहीं है",
  participantsPerPage: "प्रति पृष्ठ प्रतिभागी:",
  actionFailed: "क्रिया: विफल रही है",
  failedToRemoveUser: "उपयोगकर्ता को हटाने में विफल",
  bestScoreAcrossAttemptsInfo:
    "एकाधिक प्रयासों में प्राप्त सर्वोत्तम स्कोर को दर्शाता है।",
  successfullyRemovedUser: "उपयोगकर्ता को सफलतापूर्वक हटा दिया गया",
  successfullyReinvitedUser: "उपयोगकर्ता को सफलतापूर्वक पुनः आमंत्रित किया गया",
  reinviteTooltip:
    "उन प्रतिभागियों को पुनः आमंत्रित करें जिन्होंने अभी तक चल रहे मूल्यांकन को शुरू नहीं किया है",
  reInvite: "आमंत्रित कर रहे हैं",
  noParticipantsInvitedYet:
    "अभी तक किसी भी प्रतिभागी को आमंत्रित नहीं किया गया है",
  scheduleExpired: "शेड्यूल समाप्त हो गया",
  assessmentIsOngoing: "मूल्यांकन जारी है",
  assessmentCompleted: "मूल्यांकन पूरा हो गया",
  resultNotProcessed: "परिणाम संसाधित नहीं हुआ",
  assessmentNotStarted: "मूल्यांकन शुरू नहीं हुआ",
  remove: "निकालना",
  confirmReInvitation: "पुनः आमंत्रण की पुष्टि करें",
  confirmReinviteMessage:
    "क्या आप वाकई उन प्रतिभागियों को फिर से आमंत्रित करना चाहते हैं जिन्होंने अभी तक चालू मूल्यांकन शुरू नहीं किया है?",
  removeUserWithNamePrompt: "क्या आप वाकई '{{name}}' को हटाना चाहते हैं?",
  groupType: "समूह प्रकार",
  objectiveGroupType: "वस्तुनिष्ठ",
  codingGroupType: "कोडिंग",
  subjectiveTextSpeakingGroupType: "व्यक्तिपरक (पाठ/बोलना)",
  groupTypeImmutableInfo:
    "समूह प्रकार को बाद में नहीं बदला जा सकता. केवल उस प्रकार के प्रश्न ही जोड़े जा सकते हैं.",
  sameMarkGroupingTitle:
    "प्रश्नों को केवल तभी समूहीकृत किया जा सकता है यदि उनका अंक मान समान हो",
  sameMarkGroupingDescription:
    "किसी समूह में अंक मान (उदाहरण के लिए, 2-अंक और 5-अंक) को मिलाने से केवल कुछ प्रश्न चुने जाने पर अलग-अलग सेक्शन के अंक प्राप्त हो सकते हैं। स्कोर को सुसंगत बनाए रखने के लिए समान अंक वाले प्रश्नों का समूह बनाएं।",
  searchQuestion: "प्रश्न खोजें",
  addAllSelectedQuestions: "सभी {{count}} चयनित प्रश्न जोड़ें",
  singleQuestionSelectedCount: "{{count}} प्रश्न चयनित",
  allQuestionsSelectedCount: "सभी {{count}} प्रश्न चयनित",
  selectedCountOfTotalQuestions:
    "कुल {{total}} में से {{selected}} {{label}} चयनित",
  addSelectedQuestion: "चयनित प्रश्न जोड़ें",
  validationErrors: "सत्यापन त्रुटियाँ",
  failedToAddToGroup: "समूह में जोड़ने में विफल",
  questionsAddedSuccessfullyWithCount: "{{count}} प्रश्न सफलतापूर्वक जोड़े गए",
  successfullyUpdatedAssessment: "मूल्यांकन सफलतापूर्वक अपडेट किया गया",
  editCustomTnc: "कस्टम नियम और शर्तें संपादित करें",
  addCustomTnc: "कस्टम नियम और शर्तें जोड़ें",
  attributes: "विशेषताएं",
  added: "जोड़े गए",
  addAttributes: "विशेषताएं जोड़ें",
  clickHereToAddEditAttributes:
    "विशेषताएं जोड़ने/संपादित करने के लिए यहाँ क्लिक करें",
  clickHereToAddAttributes: "विशेषताएं जोड़ने के लिए यहाँ क्लिक करें",
  addTncAndSave: "नियम एवं शर्तें जोड़ें और सहेजें",
  savedWithFollowingErrors: "निम्नलिखित त्रुटियों के साथ सहेजा गया",
  selectDomain: "डोमेन चुनें",
  selectRegion: "क्षेत्र चुनें",
  selectUsage: "उपयोग चुनें",
  selectCategoryFirst: "पहले श्रेणी चुनें",
  selectSubCategory: "उप-श्रेणी चुनें",
  addAttributesAndSave: "विशेषताएं जोड़ें और सहेजें",
  questionPaperTimer: "प्रश्न पत्र टाइमर",
  sectionLevelTimer: "अनुभाग स्तर टाइमर",
  questionLevelTimer: "प्रश्न स्तर टाइमर",
  loginWindowDescription:
    "उम्मीदवार शुरू होने के समय के बाद केवल एक सीमित समय अवधि के भीतर ही शामिल हो सकते हैं।",
  durationBasedDescription:
    "समाप्ति समय की गणना स्वचालित रूप से शुरू होने के समय + परीक्षा की अवधि से की जाती है।",
  deadlineDescription:
    "निश्चित शुरू और समाप्ति समय; उम्मीदवारों को समय सीमा से पहले परीक्षा पूरी करनी होगी।",
  loginWindowInfo:
    "लॉगिन विंडो वह समय (मिनटों में) है जिसके दौरान उम्मीदवार निर्धारित शुरू होने के समय के बाद मूल्यांकन शुरू कर सकते हैं। एक बार लॉगिन विंडो बंद होने के बाद, कोई भी नया उम्मीदवार प्रवेश नहीं कर सकता है। लॉगिन विंडो प्रश्न पत्र की अवधि से कम या उसके बराबर होनी चाहिए।",
  assessmentDurationInfo:
    "केवल शुरू होने का समय सेट करें। सिस्टम परीक्षा की अवधि जोड़कर समाप्ति समय की गणना स्वचालित रूप से कर लेगा।",
  startTimeMinAheadInfo:
    "शुरू होने का समय वर्तमान समय से कम से कम 15 मिनट आगे होना चाहिए।",
  loginWindowExample:
    "उदाहरण: यदि शुरू होने का समय सुबह 9:00 बजे है और लॉगिन विंडो 30 मिनट की है, तो उम्मीदवार 5 मिनट के अतिरिक्त बफर के साथ सुबह 9:00-9:30 बजे के बीच शुरू कर सकते हैं।",
  assessmentDurationExample:
    "उदाहरण: यदि शुरू होने का समय सुबह 9:00 बजे है और परीक्षा की अवधि 60 मिनट है, तो मूल्यांकन 5 मिनट के अतिरिक्त बफर के साथ सुबह 10:00 बजे समाप्त होगा।",
  freeFlow: "मुक्त प्रवाह",
  oneByOne: "एक-एक करके",
  subjectiveNoResultInfo: "विषयपरक 'कोई परिणाम नहीं' की जानकारी",
  candidateResultVisibility: "उम्मीदवार के लिए परिणाम की दृश्यता",
  noResult: "कोई परिणाम नहीं",
  passPercentageRangeError: "उत्तीर्ण प्रतिशत सीमा त्रुटि",
  attemptsAllowedInfo: "अनुमत प्रयासों की जानकारी",
  maxAttemptsError: "त्रुटि: अधिकतम प्रयासों की सीमा पार हो गई है",
  maximumAttemptsInfo: "अधिकतम प्रयासों की जानकारी",
  limitedAttempts: "सीमित प्रयास",
  coolOffDescription: "कूल-ऑफ (प्रतीक्षा) अवधि का विवरण",
  noCoolOffPeriod: "कोई कूल-ऑफ अवधि नहीं",
  waitFor: "प्रतीक्षा करें",
  hours: "घंटे",
  days: "दिन",
  whatLearnersWillSee: "शिक्षार्थी क्या देखेंगे",
  unlimitedAttemptsInfo:
    "इस मूल्यांकन के लिए आपके पास असीमित प्रयास उपलब्ध हैं।",
  waitBeforeNextAttemptPrefix:
    "प्रत्येक प्रयास के बाद आपको प्रतीक्षा करनी होगी",
  waitBeforeNextAttemptSuffix: "अपना अगला प्रयास शुरू करने से पहले।",
  waitBeforeNextAttempt:
    "प्रत्येक प्रयास के बाद अपना अगला प्रयास शुरू करने से पहले आपको {duration} प्रतीक्षा करनी होगी।",
  singleAttemptInfo: "इस मूल्यांकन के लिए आपके पास 1 प्रयास उपलब्ध है।",
  remainingAttemptsInfoPrefix: "आपके पास",
  remainingAttemptsInfoMiddle: "में से",
  remainingAttemptsInfoSuffix: "प्रयास इस मूल्यांकन के लिए उपलब्ध हैं।",
  remainingAttemptsInfo:
    "इस मूल्यांकन के लिए आपके पास {total} में से {remaining} प्रयास उपलब्ध हैं।",
  enableCertificate: "प्रमाणपत्र सक्षम करें",
  enableCertificateDescription:
    "मूल्यांकन सफलतापूर्वक पूरा करने पर उम्मीदवारों को प्रमाणपत्र जारी करें।",
  maxAllowed100: "अधिकतम 100 की अनुमति है",
  scheduleAssessment: "मूल्यांकन शेड्यूल करें",
  privateAssessmentLabel: "निजी मूल्यांकन",
  publicAssessmentLabel: "सार्वजनिक मूल्यांकन",
  privateAssessmentDescription:
    "यह मूल्यांकन केवल आमंत्रण-आधारित है और निर्धारित प्रारंभ व समाप्ति समय-सीमा के भीतर ही उपलब्ध है।",
  publicAssessmentDescription:
    "यह मूल्यांकन स्व-आवंटित और आमंत्रण-आधारित दोनों प्रकार की पहुंच का समर्थन करता है, बिना किसी निश्चित पहुंच समय-सीमा के।",
  schedulePublicAssessment: "सार्वजनिक मूल्यांकन शेड्यूल करें",
  successfullyPublishedAssessment: "मूल्यांकन सफलतापूर्वक प्रकाशित किया गया",
  publishWithoutProctoringPrompt:
    "बिना ऑनलाइन निगरानी (Proctoring) के प्रकाशित करें?",
  publishAssessmentPrompt: "मूल्यांकन प्रकाशित करें?",
  sectionScoreAnalysis: "अनुभाग स्कोर विश्लेषण",
  sectionScoreAnalysisOverview: "अनुभाग स्कोर विश्लेषण का अवलोकन",
  section: "अनुभाग",
  noSectionDataAvailable: "कोई अनुभाग डेटा उपलब्ध नहीं है",
  difficultyLevelAnalysis: "कठिनाई स्तर का विश्लेषण",
  browserViolations: "ब्राउज़र उल्लंघन",
  videoViolations: "वीडियो उल्लंघन",
  times: "बार",
  statusMessageUnavailable: "स्थिति संदेश अनुपलब्ध",
  viewViolationEvidence: "उल्लंघन के साक्ष्य देखें",
  noBrowserViolationsDetected: "कोई ब्राउज़र उल्लंघन नहीं पाया गया",
  noVideoViolationsDetected: "कोई वीडियो उल्लंघन नहीं पाया गया",
  candidateNotAttemptedCodingMessage:
    "संदेश: उम्मीदवार ने कोडिंग का प्रयास नहीं किया",
  candidateCode: "उम्मीदवार का कोड",
  candidateScore: "उम्मीदवार का स्कोर",
  compilationCount: "कंपाइलेशन की संख्या",
  submissionCount: "सबमिशन की संख्या",
  timeTaken: "लिया गया समय",
  testCaseReport: "टेस्ट केस रिपोर्ट",
  performanceAndCompilationMetrics: "प्रदर्शन और कंपाइलेशन मेट्रिक्स",
  totalTestCases: "कुल टेस्ट केस",
  testCasesPassed: "सफल रहे टेस्ट केस",
  testCaseDetails: "टेस्ट केस का विवरण",
  searchQuestions: "प्रश्न खोजें",
  clearSearch: "खोज साफ़ करें",
  question: "प्रश्न",
  isSelected: "चयनित है",
  areSelected: "चयनित हैं",
  selected: "चयनित",
  questionsPerPage: "प्रति पृष्ठ प्रश्न:",
  publishQuestions: "प्रश्न प्रकाशित करें",
  send: "भेजें",
  move: "स्थानांतरित करें",
  publishQuestionsConfirmation:
    "क्या आप वाकई {{count}} {{label}} प्रकाशित करना चाहते हैं?",
  sendForReviewConfirmation:
    "क्या आप वाकई समीक्षा के लिए {{count}} {{label}} भेजना चाहते हैं?",
  moveToDraftConfirmation:
    "क्या आप वाकई {{count}} {{label}} को ड्राफ्ट में स्थानांतरित करना चाहते हैं?",
  bulkPublishDisclaimer:
    "कृपया प्रकाशित करने से पहले सत्यापित करें कि सभी चयनित प्रश्न पूर्ण, सटीक और इच्छित रूप में प्रदर्शित हैं।",
  bulkReviewDisclaimer:
    "कृपया समीक्षा के लिए भेजने से पहले सत्यापित करें कि सभी चयनित प्रश्न पूर्ण, सटीक और इच्छित रूप में प्रदर्शित हैं।",
  bulkDraftDisclaimer:
    "कृपया ड्राफ्ट में स्थानांतरित करने से पहले सत्यापित करें कि सभी चयनित प्रश्न पूर्ण, सटीक और इच्छित रूप में प्रदर्शित हैं।",
  questionsUnderProcess:
    "प्रश्नों पर कार्रवाई चल रही है, कृपया प्रश्नों की स्थिति की जांच करने के लिए विवरण देखें पर क्लिक करें।",
  mixedStatusesSelected: "मिश्रित स्थितियाँ चुनी गईं",
  mixedStatusesWarning:
    "कृपया आगे बढ़ने से पहले सुनिश्चित करें कि सभी चयनित प्रश्नों की स्थिति समान हो।",
  selectionLimitReached: "चयन सीमा समाप्त",
  selectionLimitWarning:
    "आप थोक कार्रवाई के लिए {{count}} से अधिक प्रश्नों का चयन नहीं कर सकते। दूसरा प्रश्न चुनने से पहले एक प्रश्न को अचयनित करें।",
  knowMore: "और जानें",
  guideLearnersRightDepth:
    "अपने शिक्षार्थियों को ऐसे प्रश्नों से मार्गदर्शन दें जो सही गहराई से मेल खाते हों।",
  bloomCreateDescription:
    "मूल्यांकन करें कि शिक्षार्थी कई अवधारणाओं का उपयोग करके नए सिस्टम या कोड समाधानों को डिज़ाइन, आर्किटेक्ट या निर्माण करने में सक्षम है या नहीं।",
  bloomEvaluateDescription:
    "जांचें कि क्या शिक्षार्थी कोड का गंभीर रूप से मूल्यांकन कर सकता है, विकल्पों को सही ठहरा सकता है, या विभिन्न समाधानों का मूल्यांकन कर सकता है।",
  bloomAnalyzeDescription:
    "कोड को तोड़ने, डीबग करने, लॉजिक को ट्रेस करने, या तकनीकी प्रणालियों में पैटर्न की पहचान करने की शिक्षार्थी की क्षमता का परीक्षण करें।",
  bloomApplyDescription:
    "मूल्यांकन करें कि क्या शिक्षार्थी व्यावहारिक कोडिंग समस्याओं या वास्तविक दुनिया के परिदृश्यों को हल करने के लिए अवधारणाओं को लागू कर सकता है।",
  bloomUnderstandDescription:
    "जांचें कि क्या शिक्षार्थी अवधारणाओं को अपने शब्दों में समझ और समझा सकता है या व्यवहार की व्याख्या कर सकता है।",
  bloomRememberDescription:
    "बुनियादी परिभाषाओं, सिंटैक्स और तथ्यात्मक जानकारी को याद रखने की शिक्षार्थी की क्षमता का मूल्यांकन करें।",
  bloomVerbCreate: "बनाएं (Create)",
  bloomVerbDesign: "डिज़ाइन करें (Design)",
  bloomVerbConstruct: "निर्माण करें (Construct)",
  bloomVerbDevelop: "विकसित करें (Develop)",
  bloomVerbEvaluate: "मूल्यांकन करें (Evaluate)",
  bloomVerbJustify: "औचित्य साबित करें (Justify)",
  bloomVerbDefend: "बचाव करें (Defend)",
  bloomVerbAssess: "आकलन करें (Assess)",
  bloomVerbAnalyze: "विश्लेषण करें (Analyze)",
  bloomVerbDifferentiate: "अंतर करें (Differentiate)",
  bloomVerbOrganize: "व्यवस्थित करें (Organize)",
  bloomVerbCompare: "तुलना करें (Compare)",
  bloomVerbApply: "लागू करें (Apply)",
  bloomVerbUse: "उपयोग करें (Use)",
  bloomVerbDemonstrate: "प्रदर्शित करें (Demonstrate)",
  bloomVerbSolve: "हल करें (Solve)",
  bloomVerbExplain: "समझाएं (Explain)",
  bloomVerbDescribe: "वर्णन करें (Describe)",
  bloomVerbSummarize: "संक्षेप में बताएं (Summarize)",
  bloomVerbInterpret: "व्याख्या करें (Interpret)",
  bloomVerbList: "सूचीबद्ध करें (List)",
  bloomVerbDefine: "परिभाषित करें (Define)",
  bloomVerbName: "नाम बताएं (Name)",
  bloomVerbRecall: "याद करें (Recall)",
  bloomVerbRecognize: "पहचानें (Recognize)",
  bloomCreateExample1:
    "React और Redux का उपयोग करके एक सिंगल-पेज एप्लिकेशन बनाएं।",
  bloomCreateExample2: "एक राइड-शेयरिंग ऐप डेटाबेस के लिए स्कीमा डिज़ाइन करें।",
  bloomCreateExample3:
    "GitHub Actions का उपयोग करके एक CI/CD पाइपलाइन विकसित करें।",
  bloomEvaluateExample1:
    "माइक्रोसर्विसेज आर्किटेक्चर में SQL पर NoSQL का उपयोग करने के फायदे और नुकसान का मूल्यांकन करें।",
  bloomEvaluateExample2:
    "React कंपोनेंट के प्रदर्शन को अनुकूलित करने के लिए सुधारों की सिफारिश करें।",
  bloomAnalyzeExample1: "मर्ज सॉर्ट और क्विकसॉर्ट के प्रदर्शन की तुलना करें।",
  bloomAnalyzeExample2: "इस रिकर्सिव फ़ंक्शन के मेमोरी उपयोग का विश्लेषण करें।",
  bloomAnalyzeExample3:
    "इस जावास्क्रिप्ट कोड ब्लॉक में त्रुटियों को वर्गीकृत करें।",
  bloomApplyExample1:
    "सरणी (array) में एक तत्व खोजने के लिए बाइनरी सर्च एल्गोरिदम लागू करें।",
  bloomApplyExample2:
    "पायथन में फाइबोनैचि श्रृंखला को प्रिंट करने के लिए एक लूप का उपयोग करें।",
  bloomApplyExample3:
    "हैश मैप का उपयोग करके वास्तविक दुनिया की समस्या को हल करें।",
  bloomUnderstandExample1:
    "LIFO सिद्धांत का उपयोग करके समझाएं कि स्टैक कैसे काम करता है।",
  bloomUnderstandExample2:
    "जावास्क्रिप्ट में var, let और const के बीच अंतर का वर्णन करें।",
  bloomUnderstandExample3: "दिए गए SQL क्वेरी के आउटपुट की व्याख्या करें।",
  bloomRememberExample1: "हाइपरलिंक बनाने के लिए सही HTML टैग की पहचान करें।",
  bloomRememberExample2:
    "ऑब्जेक्ट-ओरिएंटेड प्रोग्रामिंग (OOP) के चार स्तंभों के नाम बताएं।",
  bloomRememberExample3: "जावा में प्रिमिटिव डेटा प्रकारों को सूचीबद्ध करें।",
  commonVerbs: "सामान्य क्रियाएँ",
  exampleQuestions: "उदाहरण प्रश्न",
  noExamplesAvailable: "कोई उदाहरण उपलब्ध नहीं है।",
  candidateResponse: "उम्मीदवार की प्रतिक्रिया",
  correctQuestions: "सही प्रश्न",
  totalQuestions: "कुल प्रश्न",
  correctQuestionPercentage: "सही प्रश्न प्रतिशत",
  performance: "प्रदर्शन",
  level: "स्तर",
  noOfQuestions: "प्रश्नों की संख्या",
  correctAttempts: "सही प्रयास",
  correctness: "सटीकता",
  partiallyCorrect: "आंशिक रूप से सही",
  partiallyCorrectPercentage: "आंशिक रूप से सही प्रतिशत",
  rescheduleAssessmentPrompt:
    'कृपया पुष्टि करें कि क्या आप "{{title}}" शीर्षक वाले मूल्यांकन को पुनर्निर्धारित करना चाहते हैं',
  assessmentAlreadyStarted: "मूल्यांकन पहले ही शुरू हो चुका है",
  readMore: "और पढ़ें",
  best: "सर्वश्रेष्ठ",
  latest: "नवीनतम",
  allQuestions: "सभी प्रश्न",
  myQuestions: "मेरे प्रश्न",
  publicQuestions: "सार्वजनिक प्रश्न",
  remarks: "टिप्पणियाँ",
  addRemarks: "टिप्पणी जोड़ें",
  noGroupsAdded: "अभी तक कोई समूह नहीं जोड़ा गया है",
  addGroupInfo:
    'प्रश्न जोड़ना शुरू करने के लिए पहले एक समूह बनाएं। शुरुआत करने के लिए नीचे दिए गए "अनुभाग में समूह जोड़ें" बटन पर क्लिक करें।',
  exitPreview: "पूर्वावलोकन से बाहर निकलें",
  preview: "पूर्वावलोकन",
  problemStatementNotAdded: "समस्या विवरण नहीं जोड़ा गया",
  durationDayUnit: "दिन",
  durationDaysUnit: "दिन",
  durationHourUnit: "घं",
  durationHoursUnit: "घं",
  durationMinuteUnit: "मिन",
  customFieldAddedForSingleLanguage:
    "कस्टम {{fieldLabel}} {{total}} में से {{current}} भाषा के लिए जोड़ा गया",
  customFieldAddedForMultipleLanguages:
    "कस्टम {{fieldLabel}} {{total}} में से {{current}} भाषाओं के लिए जोड़ा गया",
  email: "ईमेल",
  tagInputHint: "कॉमा से अलग करें",
  enterOptions: "विकल्प दर्ज करें",
  groupNotFound: "समूह नहीं मिला",
  sheetNotFound: "शीट नहीं मिली",
  missingHeaders: "आवश्यक हेडर गायब हैं",
  assetNotFound: "संसाधन नहीं मिला",
  noValidDataFound: "कोई मान्य डेटा नहीं मिला",
  notFoundPID: "प्रतिभागी नहीं मिला।",
  invalidParticipants: "अमान्य प्रतिभागी।",
  alreadyAdded: "प्रतिभागी पहले से जोड़ा गया है।",
  duplicateData: "डुप्लिकेट डेटा मिला।",
  invalidData: "अमान्य डेटा।",
  warnings: "चेतावनियाँ",
  assignedToMyself: "मुझे सौंपा गया (स्व-प्रशिक्षण)",
  assignedByMe: "मेरे द्वारा सौंपा गया (मेरे कार्य)",
  urlCopiedToClipboard: "URL क्लिपबोर्ड पर कॉपी हो गया!",
  failedToCopyUrl: "URL की प्रतिलिपि बनाने में विफल।",
  content: "शिक्षण सामग्री",
  platformHelp: "प्लेटफ़ॉर्म सहायता",
  privacyPolicy: "गोपनीयता नीति",
  logout: "लॉग आउट",
  logoutConfirmTitle: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
  logoutConfirmDescription:
    "जा रहे हैं? आप कभी भी वापस आकर वहीं से जारी रख सकते हैं जहाँ आपने छोड़ा था।",
  stayEngaged: "जुड़े रहें"
} as const;
export default hi;
